exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row-bg-top{\r\n    background-color: #f2eded;\r\n    margin: 10px 0px 0px 0px;\r\n}\r\n.row-bg{\r\n    background-color: #f2eded;\r\n    margin: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pages/transaction/op/inbound/asn/submit-asn/choose-account/choose-account.css
// module id = 788
// module chunks = 7